import { render, staticRenderFns } from "./LoanCalculator.vue?vue&type=template&id=28fb10e2&scoped=true&"
import script from "./LoanCalculator.vue?vue&type=script&lang=js&"
export * from "./LoanCalculator.vue?vue&type=script&lang=js&"
import style0 from "./LoanCalculator.vue?vue&type=style&index=0&id=28fb10e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb10e2",
  null
  
)

export default component.exports